export default function selectTheme(theme) {
  return {
    ...theme,
    colors: {
      ...theme.colors,
      // primary: 'hsl(0,0%,80%)',
      primary: '#21174F', // dropdown menu item selected
      primary75: 'hsl(0,0%,90%)',
      primary50: 'hsl(0,0%,90%)',
      // primary25: 'hsl(0,0%,90%)',
      primary25: '#98D6FF', // dropdown menu item hover
      neutral0: 'white',
      neutral20: 'hsl(0,0%,80%)', //'hsl(0,0%,90%)',
      neutral30: 'hsl(0,0%,90%)',
      neutral50: 'hsl(0,0%,70%)',
      // neutral60: '#CE263D',
      // neutral80: '#CE263D',
      neutral60: '#21174F',
      neutral80: '#21174F',
      neutral90: 'teal',
    },
    spacing: {
      ...theme.spacing,
      controlHeight: '45px',
    },
  };
}

const getOptionColor = (isDisabled, isSelected, isFocused) => {
  if (isDisabled) {
    return {
      color: 'hsl(0,0%,65%)',
      backgroundColor: 'transparent',
    };
  }
  if (isFocused) {
    return {
      color:' inherit',
      backgroundColor: 'hsl(0,0%,90%)',
    };
  }
  if (isSelected) {
    return {
      color: 'inherit',
      backgroundColor: 'transparent',
    };
  }

  return {
    color: 'inherit',
    backgroundColor: 'transparent',
  };
};
export const styles = {

  option: (base, { isSelected, isDisabled, isFocused }) => {
    const optionColors = getOptionColor(isDisabled, isSelected, isFocused);
    return {
      ...base,
      ...optionColors,
    };
  },
  spacing: base => ({
    ...base,
    height: 45,
    minHeight: 45
  })
};
